export const groupByTime = (observations) => {
    const minRangeWidth = 24 * 3600000;
    const paddingTime = 3600000;
    let result = [];
    observations.reduce((groups, observation) => {
        const lastGroup = groups.at(-1);
        if (!lastGroup || (observation.time - lastGroup.range.end > minRangeWidth)) {
            //either first observation or time to far from end range of last group
            groups.push({
                range: { start: observation.time - paddingTime, end: observation.time - paddingTime + minRangeWidth },
                observations: [observation]
            });
        }
        else {
            lastGroup.observations.push(observation);
            lastGroup.range.end = Math.max(lastGroup.range.end, observation.time + paddingTime);
        }
        return groups;
    }, result);
    return result;
};
